"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClinicalKeywordsStates = exports.ClinicalKeywordsEventType = void 0;
var ClinicalKeywordsEventType;
(function (ClinicalKeywordsEventType) {
    ClinicalKeywordsEventType["FETCH_CLINICAL_KEYWORDS"] = "FETCH_CLINICAL_KEYWORDS";
    ClinicalKeywordsEventType["DONE_INVOKE_FETCH_CLINICAL_KEYWORDS"] = "done.invoke.fetchClinicalKeywords";
    ClinicalKeywordsEventType["ERROR_FETCH_CLINICAL_KEYWORDS"] = "error.platform.fetchClinicalKeywords";
})(ClinicalKeywordsEventType = exports.ClinicalKeywordsEventType || (exports.ClinicalKeywordsEventType = {}));
var ClinicalKeywordsStates;
(function (ClinicalKeywordsStates) {
    ClinicalKeywordsStates["INIT"] = "init";
    ClinicalKeywordsStates["IDLE"] = "idle";
    ClinicalKeywordsStates["LOADING_CLINICAL_KEYWORDS"] = "loadingClinicalKeywords";
    ClinicalKeywordsStates["LOAD_CLINICAL_KEYWORDS_SUCCESS"] = "loadClinicalKeywordsSuccess";
    ClinicalKeywordsStates["LOAD_CLINICAL_KEYWORDS_FAILURE"] = "loadClinicalKeywordsFailure";
})(ClinicalKeywordsStates = exports.ClinicalKeywordsStates || (exports.ClinicalKeywordsStates = {}));
//# sourceMappingURL=typings.js.map